var React = require('react');

function VoOffshore48px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M47 46h-7l-2-.2V39h3a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-7.3l12-10.2a1 1 0 0 0-1.1-1.7l-17.2 7.6L25 5.9a1 1 0 0 0-1-.9h-1V1a1 1 0 0 0-2 0v4h-1a1 1 0 0 0-1 .9L16.1 31H16v-7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3v7H1a1 1 0 0 0 0 2h25c.1 0 4.8-.1 7-2.2 2.2 2.1 6.9 2.2 7 2.2h7a1 1 0 0 0 0-2zm-7.8-22.3L30.6 31h-2.7l-.3-2.2zM20.9 7h2.2l2.8 24h-7.8zM4 25h10v7a1 1 0 0 0 1 1h25v4H4zm4 21v-7h6v7zm8 0v-7h12v6.8l-2 .2zm17.9-2.3a1 1 0 0 0-1.9 0 3.2 3.2 0 0 1-2 1.6V39h6v6.3a3.2 3.2 0 0 1-2.1-1.6zM8 28a1 1 0 1 1-1-1 1 1 0 0 1 1 1zm4 0a1 1 0 1 1-1-1 1 1 0 0 1 1 1z"}));
}

VoOffshore48px.displayName = "VoOffshore48px";

VoOffshore48px.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = VoOffshore48px;

VoOffshore48px.default = VoOffshore48px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/vo-offshore-48px.svg
// module id = 1177
// module chunks = 0